import { TablePagination } from '@mui/material';
import styled from 'styled-components';
import { theme } from '../../theme';

export const CellParent = styled.div<{ selected?: boolean; alternate?: boolean }>`
  padding: 0px 10px;
  margin-top: 2px;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
  height: 100%;
  overflow: hidden;
  transition: background-color 0.5s;
  background-color: ${({ selected }) =>
    selected ? theme.palette.custom.secondaryXXLight : theme.palette.common.white};
  &:nth-child(even) {
    background-color: ${({ selected, alternate }) =>
      selected ? theme.palette.custom.secondaryXXLight : alternate ? theme.palette.grey[100] : ''};
  }
  &:hover {
    background-color: ${() => theme.palette.custom.secondaryXXLight};
  }
`;

/**
 * .sc-eGugkK .sc-jTjUTQ:nth-child(odd){
    background-color: lightgray
}
 */

export const Container = styled.div`
  position: relative;
  z-index: 1000;
`;

export const ListActionWrapper = styled.div`
  position: absolute;
  z-index: 0;
  top: -25px;
  right: 0;
  margin-bottom: 2px !important;
  /* border-top: 2px solid ${() => theme.palette.primary.light};
  border-left: 2px solid ${() => theme.palette.primary.light};
  border-right: 2px solid ${() => theme.palette.primary.light}; */
  border-radius: 10px 10px 0 0;
  background-color: ${() => theme.palette.secondary.light};
  transition: top 0.4s ease;
  will-change: top;
  &:hover {
    top: -75px;
    z-index: 0; /* Nessuna animazione su z-index */
  }
`;

export const ListActionContainer = styled.div`
  padding: 4px 4px 4px 4px;
`;

export const ListWrapper = styled.div<{ corner?: boolean }>`
  position: relative;
  background-color: ${() => theme.palette.secondary.light};
  display: flex;
  flex-direction: column;
  /* border: 2px solid ${() => theme.palette.primary.light}; */
  border-radius: ${(p) => (p.corner ? '10px 0 10px 10px' : '10px')};
  overflow: hidden;
  max-height: calc(100vh - 80px);
`;

export const ListHeader = styled.div<{ gridTemplateColumns: string }>`
  display: grid;
  grid-template-columns: ${(p) => p.gridTemplateColumns};
  /* border-bottom: 1px solid ${() => theme.palette.primary.light}; */
  align-items: center;
  background-color: ${() => theme.palette.secondary.light} !important;
`;

export const ListFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 5px;
  height: 35px;
  align-items: center;
  background-color: ${() => 'rgb(214 212 203)'};
`;

export const ItemWrapper = styled.div<{
  gridTemplateColumns: string;
  selected?: boolean;
  alternate?: boolean;
  isRecentlyOpened?: boolean;
}>`
  display: grid;
  grid-template-columns: ${(p) => p.gridTemplateColumns};
  align-items: center;
  /* border-bottom: 1px solid ${() => theme.palette.primary.light}; */
  & > * {
    background-color: ${({ isRecentlyOpened }) =>
      isRecentlyOpened ? theme.palette.custom.primaryXLight + ' !important' : ''};
  }
  &:nth-child(even) > * {
    background-color: ${({ alternate, selected }) =>
      selected ? theme.palette.custom.secondaryXXLight : alternate ? theme.palette.grey[100] : ''};
  }
  :hover > * {
    /* background-color: ${() => theme.palette.custom.secondaryXXLight};
    transition: background-color 0.3s, scale 0.2; */
    cursor: pointer;
  }
`;

export const ListContainer = styled.div<{ maxHeight?: string }>`
  background-color: ${() => theme.palette.common.white};
  overflow-y: auto;
  /* max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : 'calc(100vh - 150px)')}; */
  ::-webkit-scrollbar-track {
    background-color: ${() => theme.palette.common.white};
    border-radius: 5px;
  }
  ::-webkit-scrollbar {
    width: 7px;
    border-radius: 5px;
    background-color: ${() => theme.palette.common.white};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: ${() => theme.palette.primary.main};
  }
`;

export const ListMessageWrapper = styled.div`
  min-height: 100px;
  text-align: center;
`;

export const StyledTablePagination = styled(TablePagination)`
  .MuiTablePagination-selectLabel {
    font-size: 15px;
    font-weight: 600;
  }
  .MuiTablePagination-selectIcon {
    color: ${() => theme.palette.primary.main};
    font-size: 20px;
  }
  .MuiTablePagination-select {
    font-size: 15px;
    font-weight: 600;
  }
  .MuiTablePagination-displayedRows {
    font-size: 15px;
    font-weight: 600;
  }
`;

export const HeaderWrapper = styled.div<{
  sortable?: number;
  collapsible?: number;
  collapsed?: number;
  disabled?: number;
  alternate?: boolean;
  py?: string;
}>`
  overflow: hidden;
  position: relative;
  height: 100%;
  padding: 5px 10px;
  color: ${({ collapsed }) =>
    collapsed ? theme.palette.primary.light : theme.palette.primary.main};
  background-color: ${({ collapsed }) =>
    collapsed ? theme.palette.primary.light : theme.palette.secondary.light};
  &:nth-child(even) {
    background-color: ${({ collapsed, alternate }) =>
      alternate ? (collapsed ? theme.palette.primary.light : theme.palette.grey[300]) : ''};
  }
  :hover {
    color: ${({ collapsed }) =>
      collapsed ? theme.palette.primary.main : theme.palette.primary.main};
    cursor: ${({ collapsible, collapsed, sortable, disabled }) =>
      disabled
        ? 'not-allowed'
        : sortable
          ? 'pointer'
          : collapsible
            ? collapsed
              ? 'col-resize'
              : 'pointer'
            : 'default'};
    background-color: ${({ collapsible, collapsed, sortable }) =>
      sortable
        ? theme.palette.custom.primaryXXLight
        : collapsed
          ? theme.palette.primary.main
          : collapsible
            ? theme.palette.custom.primaryXXLight
            : ''};
  }
`;

export const Invalidator = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: ${() => theme.palette.grey[100]};
  opacity: 0.7;
  display: flex;
  justify-content: center;
  align-items: center;
`;
